// extracted by mini-css-extract-plugin
module.exports = {"nav":"multiidioma_nav__i_JRz","active":"multiidioma_active__iaZQO"};